var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 1.66406C5.40435 1.66406 1.66602 5.4024 1.66602 9.9974C1.66602 14.5924 5.40435 18.3307 9.99935 18.3307C14.5943 18.3307 18.3327 14.5924 18.3327 9.9974C18.3327 5.4024 14.5943 1.66406 9.99935 1.66406ZM9.99935 16.6641C6.32352 16.6641 3.33268 13.6732 3.33268 9.9974C3.33268 6.32156 6.32352 3.33073 9.99935 3.33073C13.6752 3.33073 16.666 6.32156 16.666 9.9974C16.666 13.6732 13.6752 16.6641 9.99935 16.6641Z",
    fill: "#34D399"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33273 11.3257L6.4169 9.41323L5.24023 10.5932L8.3344 13.6807L13.9227 8.0924L12.7444 6.91406L8.33273 11.3257Z",
    fill: "#34D399"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.07e75316a234aaf90eb5056349b727b0.svg";
export { ForwardRef as ReactComponent };